import { Reducer } from 'redux';
import { IDataState, DataActionTypes } from './types';
import { API_CALLS } from '../../utilities/constants';
import { StudentActionTypes } from '../student/types';
import { UploadFileStatus } from '../../types/index.d';

const initialState: IDataState = {
  isConfigLoading: false,
  isConfigLoaded: false,
  isStudentLoaded: false,
  agentSuggestions: [],
  apiCallsInProgress: [],
  courseSuggestions: [],
  uploadFile: null,
  uploadError: null
};

const reducer: Reducer<IDataState> = (state = initialState, action) => {
  switch (action.type) {
    case StudentActionTypes.GET_STUDENT_RECORD_SUCCESS:
      return {
        ...state,
        isStudentLoaded: true
      };
    case DataActionTypes.GET_AGENTS: {
      const isInProgressAlready = state.apiCallsInProgress.find(x => x.callName === API_CALLS.GET_AGENTS) !== undefined;

      if (!isInProgressAlready) {
        return {
          ...state,
          apiCallsInProgress: [
            ...state.apiCallsInProgress,
            {
              callName: API_CALLS.GET_AGENTS,
              retryNumber: 0,
              timeToNextCall: 0,
              hasFailed: false
            }
          ]
        };
      }
      return state;
    }
    case DataActionTypes.GET_AGENTS_SUCCESS: {
      const results = action.payload && action.payload.length ? action.payload : [];
      return {
        ...state,
        agentSuggestions: results,
        apiCallsInProgress: state.apiCallsInProgress.filter(x => x.callName !== API_CALLS.GET_AGENTS)
      };
    }
    case DataActionTypes.GET_AGENTS_FAILURE: {
      return {
        ...state,
        agentSuggestions: [],
        apiCallsInProgress: state.apiCallsInProgress.filter(x => x.callName !== API_CALLS.GET_AGENTS)
      };
    }
    case DataActionTypes.GET_COURSE_SUGGESTIONS: {
      const isInProgressAlready =
        state.apiCallsInProgress.find(x => x.callName === API_CALLS.GET_COURSES) !== undefined;

      if (!isInProgressAlready) {
        return {
          ...state,
          apiCallsInProgress: [
            ...state.apiCallsInProgress,
            {
              callName: API_CALLS.GET_COURSES,
              retryNumber: 0,
              timeToNextCall: 0,
              hasFailed: false
            }
          ]
        };
      }
      return state;
    }
    case DataActionTypes.GET_COURSE_SUGGESTIONS_SUCCESS: {
      const results = action.payload?.courses ?? [];
      return {
        ...state,
        courseSuggestions: results,
        apiCallsInProgress: state.apiCallsInProgress.filter(x => x.callName !== API_CALLS.GET_COURSES)
      };
    }
    case DataActionTypes.GET_COURSE_SUGGESTIONS_FAILURE: {
      return {
        ...state,
        courseSuggestions: [],
        apiCallsInProgress: state.apiCallsInProgress.filter(x => x.callName !== API_CALLS.GET_COURSES)
      };
    }
    case DataActionTypes.RETRY_API_CALL: {
      const { callName, retryNumber, timeToNextCall } = action.payload;

      const apiCallsInProgress = state.apiCallsInProgress;
      const callIndex = apiCallsInProgress.findIndex(item => item.callName === callName);

      if (callIndex !== -1) {
        let apiCall = apiCallsInProgress[callIndex];
        apiCall = {
          ...apiCall,
          retryNumber: retryNumber,
          timeToNextCall: timeToNextCall
        };
        return {
          ...state,
          apiCallsInProgress: [
            ...apiCallsInProgress.slice(0, callIndex),
            apiCall,
            ...apiCallsInProgress.slice(callIndex + 1)
          ]
        };
      }
      return {
        ...state,
        apiCallsInProgress: [
          ...state.apiCallsInProgress,
          {
            callName,
            retryNumber,
            timeToNextCall,
            hasFailed: false
          }
        ]
      };
    }
    case DataActionTypes.RETRY_API_CALL_SUCCESS: {
      return {
        ...state,
        apiCallsInProgress: state.apiCallsInProgress.filter(item => action.payload !== item.callName)
      };
    }
    case DataActionTypes.RETRY_API_CALL_FAILED: {
      const apiCallsInProgress = state.apiCallsInProgress;
      const apiCallIndex = apiCallsInProgress.findIndex(item => item.callName === action.payload.callName);
      if (apiCallIndex > -1) {
        let apiCall = apiCallsInProgress[apiCallIndex];
        apiCall = {
          ...apiCall,
          hasFailed: true,
          error: action.payload.error
        };
        return {
          ...state,
          apiCallsInProgress: [
            ...apiCallsInProgress.slice(0, apiCallIndex),
            apiCall,
            ...apiCallsInProgress.slice(apiCallIndex + 1)
          ]
        };
      }

      return state;
    }
    case DataActionTypes.GET_UPLOAD_FILE_URL: {
      const { fileName, fileIndex } = action.payload;
      return {
        ...state,
        uploadFile: {
          name: fileName,
          status: UploadFileStatus.UPLOADING,
          index: fileIndex,
          isFileUploading: true
        },
        uploadError: null
      };
    }
    case DataActionTypes.GET_UPLOAD_FILE_URL_FAILURE: {
      const { error } = action.payload;
      return {
        ...state,
        uploadFile: {
          ...state.uploadFile,
          status: UploadFileStatus.ERROR,
          isFileUploading: false
        },
        uploadError: error
      };
    }
    case DataActionTypes.UPLOAD_FILE_SUCCESS: {
      return {
        ...state,
        uploadFile: {
          ...state.uploadFile,
          status: UploadFileStatus.OK,
          isFileUploading: false
        },
        uploadError: null
      };
    }
    case DataActionTypes.UPLOAD_FILE_FAILURE: {
      const { error } = action.payload;
      return {
        ...state,
        uploadFile: {
          ...state.uploadFile,
          status: UploadFileStatus.ERROR,
          isFileUploading: false
        },
        uploadError: error
      };
    }
    default:
      return state;
  }
};

export { reducer as dataReducer };
